import type { HudPanelId, HudPanelStates } from './types/hud-panels';

const HUD_PANEL_IDS: readonly HudPanelId[] = ['inventory', 'map', 'commission', 'combatLog'];

/** The panels' state for an account that has never toggled one: inventory and combat log closed, map and commission open. */
export function createDefaultHudPanelStates(): HudPanelStates {
    return { inventory: false, map: true, commission: true, combatLog: false };
}

/**
 * Validates run HUD panel states (e.g. from a PATCH body or a stored
 * setting). A missing panel takes its default, so settings saved before a
 * panel existed keep the rest; returns undefined when a panel isn't a boolean.
 */
export function parseHudPanelStates(value: unknown): HudPanelStates | undefined {
    if (!value || typeof value !== 'object') {
        return undefined;
    }
    const candidate = value as Partial<Record<HudPanelId, unknown>>;
    const states = createDefaultHudPanelStates();
    for (const id of HUD_PANEL_IDS) {
        const open = candidate[id];
        if (open === undefined) {
            continue;
        }
        if (typeof open !== 'boolean') {
            return undefined;
        }
        states[id] = open;
    }
    return states;
}
